"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _reactDayPicker = require("react-day-picker");
var _locale = require("date-fns/locale");
var _dates = require("../../utils/dates");
var _IconErrorOutline = _interopRequireDefault(require("../../icons/General/IconErrorOutline"));
var _ = require("../..");
var _reactPopper = require("react-popper");
var _dateFns = require("date-fns");
var _react2 = require("@emotion/react");
var _Keyboard = require("../../enums/Keyboard");
require("react-day-picker/style.css");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react-hooks/exhaustive-deps */
/** @jsxImportSource @emotion/react */

const FORMAT = 'dd.MM.yyyy';
const Datepicker = ({
  value,
  label,
  invalidMessage,
  maxDate,
  minDate,
  withYearMonthForm = true,
  disabled,
  disabledTitle,
  onChange,
  onBlur,
  nonInput,
  ...restProps
}) => {
  const currentYear = new Date().getFullYear();
  const toDate = maxDate ? new Date(maxDate) : new Date(currentYear, 11, 31);
  const fromDate = minDate ? new Date(minDate) : new Date(currentYear - 150, 0);
  const isMobile = (0, _.useIsMobile)();
  const pickerRef = (0, _react.useRef)(null);
  const theme = (0, _react2.useTheme)();
  const [displayMonth, setDisplayMonth] = (0, _react.useState)(value ? value : undefined);
  const [date, setDate] = (0, _react.useState)(value ? value : undefined);
  const [pickerValue, setPickerValue] = (0, _react.useState)(value ? value : undefined);
  const [inputValue, setInputValue] = (0, _react.useState)(value ? (0, _dateFns.format)(value, FORMAT) : '');
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const [popperElement, setPopperElement] = (0, _react.useState)(null);
  const [referenceElement, setReferenceElement] = (0, _react.useState)(null);
  const validation = Boolean(invalidMessage);
  (0, _react.useEffect)(() => {
    // Detect parent input value changes
    const formatted = value ? (0, _dateFns.format)(value, FORMAT) : '';
    if (inputValue === formatted) return;
    handleInputChange(formatted, true);
  }, [value]);
  (0, _react.useEffect)(() => {
    const handleClickOutside = e => {
      const node1 = pickerRef.current;
      const node2 = popperElement;
      if (node1 && node1.contains(e.target) || node2 && node2.contains(e.target)) return;
      handleClose();
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, pickerRef, popperElement]);
  const emitChange = newDate => {
    newDate?.setHours(11, 0); // To avoid timezone issues
    setDate(newDate);
    onChange && onChange(newDate);
  };
  const handleClose = () => {
    setIsOpen(false);
    setDisplayMonth(undefined);
    onBlur && onBlur();
  };
  const popper = (0, _reactPopper.usePopper)(referenceElement, popperElement, {
    placement: 'bottom-start'
  });
  const handleChange = newDate => {
    if (disabled || !newDate && !date || newDate && date && (0, _dates.datesAreOnSameDay)(newDate, date)) return;
    if (!newDate || !isDateValid(newDate)) emitChange(undefined);else emitChange(newDate);
  };
  const isDateValid = date => (0, _dateFns.isValid)(date) && (0, _dates.getDateIsValid)(date, fromDate, toDate);
  const handleInputChange = (value, emitChange) => {
    setInputValue(value);
    const date = (0, _dates.parseDate)(value, FORMAT);
    if (date && isDateValid(date)) {
      setPickerValue(date);
      setDisplayMonth(date);
    } else {
      setPickerValue(undefined);
    }
    if (emitChange) handleChange(date);
  };
  const handleDaySelect = date => {
    setPickerValue(date ? date : undefined);
    if (date) {
      setInputValue((0, _dateFns.format)(date, FORMAT));
      setTimeout(handleClose, 100);
    } else {
      setInputValue('');
    }
    handleChange(date);
  };
  const handleInputKeydown = e => setIsOpen(e.key !== _Keyboard.Key.tab);
  const Picker = (0, _jsxRuntime.jsx)(_reactDayPicker.DayPicker, {
    "aria-label": "Datovelger",
    defaultMonth: date,
    selected: pickerValue,
    mode: "single",
    onSelect: handleDaySelect,
    fromMonth: fromDate,
    toMonth: toDate,
    month: displayMonth,
    locale: _locale.nb,
    captionLayout: withYearMonthForm ? 'dropdown' : undefined,
    disabled: [{
      before: fromDate
    }, {
      after: toDate
    }],
    onMonthChange: setDisplayMonth
  });
  return (0, _jsxRuntime.jsx)(_styles.Wrapper, {
    css: theme => [_styles.styles.default(theme), validation && _styles.styles.validation, invalidMessage && _styles.styles.invalid(theme), nonInput && _styles.styles.nonInput(theme)],
    title: disabled ? disabledTitle : undefined,
    "aria-disabled": disabled,
    children: nonInput ? Picker : (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [(0, _jsxRuntime.jsxs)("label", {
        className: "input-wrapper",
        ref: pickerRef,
        children: [label && (0, _jsxRuntime.jsx)(_styles.Label, {
          children: label
        }), (0, _jsxRuntime.jsx)("input", {
          placeholder: "dd.mm.\xE5\xE5\xE5\xE5",
          value: inputValue,
          onChange: e => handleInputChange(e.currentTarget.value),
          onFocus: () => setIsOpen(true),
          onClick: () => setIsOpen(true),
          ref: setReferenceElement,
          onBlur: () => handleInputChange(inputValue && pickerValue ? (0, _dateFns.format)(pickerValue, FORMAT) : '', true),
          disabled: disabled,
          readOnly: isMobile,
          onKeyDown: handleInputKeydown,
          "aria-invalid": !!invalidMessage,
          "aria-describedby": invalidMessage ? 'error-desc' : undefined,
          "aria-label": label ? label : 'Felt for å velge dato' // Added aria-label here
          ,
          ...restProps
        }), invalidMessage && (0, _jsxRuntime.jsx)(_IconErrorOutline.default, {
          size: "16px"
        }), invalidMessage && (0, _jsxRuntime.jsx)(_styles.ErrorMessage, {
          id: "error-desc",
          theme: theme,
          children: invalidMessage
        })]
      }), isOpen && (0, _jsxRuntime.jsx)("div", {
        tabIndex: -1,
        className: "dialog-sheet",
        style: popper.styles.popper,
        ref: setPopperElement,
        role: "dialog",
        "aria-modal": "true",
        "aria-label": "Datovelger dialog",
        ...popper.attributes.popper,
        children: Picker
      })]
    })
  });
};
var _default = exports.default = Datepicker;